/*
 * @Author: LiuMouLiang
 * @Date: 2021-11-25
 */
/* eslint-disable */
import {
    getObjVal,
    trace,
    _trim,
    _toJson,
    typeOf,
    regHtmlBreakList,
    getFileExtName,
    setUrlHttps,
} from 'tools';

export const pdfURL = 'https://res.wyins.net/pdfjs/web/viewer-n.html';

export const getPageParams = function(){
    const query = getObjVal(this,'$route.query') || {};
    const params = getObjVal(this,'$route.params') || {};
    return Object.assign({},params,query);
};

export function urlReplace(url) {
    if (url && ~url.indexOf('://')) window.location.replace(url);
};

/**
 * @method  $regHtmlBreakList
 * @param   {String}          htmlStr 富文本数据
 * @return  {String}
 *
 * @desc    重置富文本数据
 * @author  liumouliang
 * @date    2022-12-22
 * @example
 *
 * regHtmlBreakList(htmlStr)
 */
export const $regHtmlBreakList = function(htmlStr){
    return htmlStr ? regHtmlBreakList(_trim(htmlStr), '<br />') : '';
};

export const hasDataLength = function(data){
    return !!getObjVal(data,'length');
};

export const toJson = function(data, def){
    if(typeOf(data) === 'string'){
        return _toJson(data) || def || [];
    };
    return data;
};

export const get_pdfURL = function(file){
    return pdfURL + `?file=${file}`;
};
export const isPdfUrl = function(url){
    const ext = getFileExtName(url);
    return ext === 'pdf';
};
export const handleFile = function(url){
    if (!url) return true;
    if(isPdfUrl(url)){
        url = get_pdfURL(url);
    }else{
        url = setUrlHttps(url);
    };
    window.open(url, '_blank');
};




// WEBPACK FOOTER //
// ./src/libs/util/util.js